"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _styles = _interopRequireDefault(require("./styles"));
var _utils = require("../../utils");
var _noResults = _interopRequireDefault(require("../../assets/no-results.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/no-array-index-key, no-use-before-define, react/jsx-no-bind */
function SearchDrawer() {
  var HASH = 'search';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  var [page, setPage] = (0, _react.useState)(0);
  var [value, setValue] = (0, _react.useState)('');
  var [results, setResults] = (0, _react.useState)([]);
  var [searched, setSearched] = (0, _react.useState)('');
  var [warning, setWarning] = (0, _react.useState)(false);
  var [selectedItem, setSelectedItem] = (0, _react.useState)();
  var {
    open,
    setOpen
  } = (0, _react.useContext)(_contexts.SearchContext);
  var {
    rendition,
    sessionToken,
    uuid,
    bookTitle,
    currentLocation
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    anchorPositionAnnotationPopover
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackingService = (0, _services.TrackingsService)(appToken, sessionToken);
  var isDesktop = (0, _core.useMediaQuery)('(min-width: 769px)');
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback, setOnHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpen(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setOpen]);
  (0, _react.useEffect)(() => {
    if (open) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [open]);
  (0, _react.useEffect)(() => {
    setWarning(value && value.length <= 2);
  }, [value]);
  (0, _react.useEffect)(() => {
    if (anchorPositionAnnotationPopover !== undefined) {
      results.forEach(result => rendition.annotations.remove(result.cfi, 'highlight'));
    }
  }, [anchorPositionAnnotationPopover, results, rendition]);
  (0, _react.useEffect)(() => {
    if (!selectedItem) return;
    if (selectedItem.location.start.location === rendition.currentLocation().start.location) return;
    if (isDesktop) {
      rendition.annotations.remove(selectedItem.cfi, 'highlight');
      results.forEach(result => rendition.annotations.remove(result.cfi, 'highlight'));
    }
    if (!isDesktop) {
      rendition.annotations.remove(selectedItem.cfi, 'highlight');
    }
    setSelectedItem();
  }, [currentLocation, selectedItem, isDesktop, rendition, results]);
  function onSearch(_x) {
    return _onSearch.apply(this, arguments);
  }
  function _onSearch() {
    _onSearch = _asyncToGenerator(function* (search) {
      var newResults = yield (0, _utils.searchBook)(rendition, search);
      yield trackingService.trackSearch({
        uuid,
        titleCover: bookTitle,
        searchTerm: value,
        searchResults: newResults.length
      });
      setPage(0);
      removeHighlights(results);
      setResults(newResults);
      setSearched(search);
      if (isDesktop) addHighlights(newResults);
    });
    return _onSearch.apply(this, arguments);
  }
  function addHighlights(items) {
    items.forEach(item => rendition.annotations.highlight(item.cfi, {}, null, 'hl-search', {
      fill: 'rgba(255, 190, 0, 0.30)'
    }));
  }
  function removeHighlights(items) {
    items.forEach(item => rendition.annotations.remove(item.cfi, 'highlight'));
  }
  function searchValue(e) {
    e.preventDefault();
    if (value.length >= 3) onSearch(value);
  }
  function goBackSearch() {
    setOpen(false);
  }
  function _clearSearch() {
    removeHighlights(results);
    setSearched('');
    setValue('');
  }
  var onClose = () => {
    removeHighlights(results);
    setSearched('');
    setOpen(false);
    setResults([]);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    open: open,
    anchor: "left",
    className: classes.drawer,
    classes: {
      paper: classes.drawerPaper
    },
    onClose: goBackSearch
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerHeader
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1",
    className: classes.title
  }, "Buscar no livro"), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "fechar",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    classes: {
      root: classes.drawerClose
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.hideOnMobile
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.searchDiv)
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.SearchBar, {
    placeholder: "Buscar por palavra, termo e trecho",
    value: value,
    onSubmit: searchValue,
    onChange: e => setValue(e.target.value),
    size: "full",
    clearSearch: () => _clearSearch(),
    goBackSearch: goBackSearch,
    showBackArrow: !isDesktop
  })), warning && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(classes.warning, " ").concat(classes.padded)
  }, "Busque por 3 ou mais caracteres"), searched && /*#__PURE__*/_react.default.createElement(SearchResults, {
    results: results,
    search: searched,
    page: page,
    setPage: setPage,
    setValue: setValue,
    removeHighlights: removeHighlights,
    setSelectedItem: setSelectedItem,
    addHighlights: addHighlights
  }));
}
function SearchResults(props) {
  var {
    search,
    results,
    page,
    setPage,
    setSelectedItem,
    addHighlights,
    removeHighlights
  } = props;
  var scrollRef = (0, _react.useRef)();
  var {
    rendition,
    bookTitle,
    getChapterName,
    jumpToPage
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    setOpen
  } = (0, _react.useContext)(_contexts.SearchContext);
  var classes = (0, _styles.default)();
  var isDesktop = (0, _core.useMediaQuery)('(min-width: 769px)');
  var itemsPerPage = 50;
  var startItems = page * itemsPerPage;
  var endItems = startItems + itemsPerPage;
  var items = results.slice(startItems, endItems);
  var backItems = startItems + items.length;
  var handleChange = (_event, value) => {
    scrollRef.current.scrollTo(0, 0);
    setPage(value - 1);
  };
  function goToPage(_x2) {
    return _goToPage.apply(this, arguments);
  }
  function _goToPage() {
    _goToPage = _asyncToGenerator(function* (item) {
      yield jumpToPage(item.cfi);
      setOpen(false);
      setSelectedItem(_objectSpread(_objectSpread({}, item), {}, {
        location: rendition.currentLocation()
      }));
      if (isDesktop) {
        removeHighlights(results);
        addHighlights(results);
      }
      if (!isDesktop) {
        rendition.annotations.highlight(item.cfi, {}, null, 'hl-search', {
          fill: 'rgba(255, 190, 0, 0.30)'
        });
      }
    });
    return _goToPage.apply(this, arguments);
  }
  function renderSearch(item) {
    return item.excerpt.split(new RegExp("(".concat(search, ")"), 'gi')).map((part, index) => /*#__PURE__*/_react.default.createElement("span", {
      key: index
    }, part.toLowerCase() === search.toLowerCase() ? /*#__PURE__*/_react.default.createElement("mark", {
      className: classes.mark
    }, part) : part));
  }
  function render(item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: classes.resultContainer,
      onClick: () => goToPage(item),
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.resultItem
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      className: classes.resultTitle,
      primary: getChapterName(item.cfi) || bookTitle,
      secondary: "P\xE1gina ".concat(rendition.book.locations.locationFromCfi(item.cfi))
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.excerpt
    }, renderSearch(item))), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.resultsDetail, " ").concat(classes.padded)
  }, "Resultados da busca ".concat(backItems, "-").concat(results.length)), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: scrollRef,
    className: "".concat(classes.scroll, " ").concat(classes.padded)
  }, items.map(render), results.length > itemsPerPage && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Pagination, {
    color: "primary",
    size: Math.ceil(results.length / itemsPerPage) > 5 ? 'small' : 'medium',
    count: Math.ceil(results.length / itemsPerPage),
    siblingCount: 1,
    onChange: handleChange,
    page: page + 1
  }))), items.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.noResults
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _noResults.default,
    alt: "no results vector"
  }), /*#__PURE__*/_react.default.createElement("h6", null, "Nenhum resultado encontrado"), /*#__PURE__*/_react.default.createElement("p", null, "Tente buscar por outra palavra ou trecho do livro.")));
}
SearchResults.propTypes = {
  results: _propTypes.default.arrayOf(_propTypes.default.shape({
    cfi: _propTypes.default.string.isRequired,
    excerpt: _propTypes.default.string.isRequired
  })).isRequired,
  search: _propTypes.default.string.isRequired,
  page: _propTypes.default.number.isRequired,
  setPage: _propTypes.default.func.isRequired,
  setSelectedItem: _propTypes.default.func.isRequired,
  addHighlights: _propTypes.default.func.isRequired,
  removeHighlights: _propTypes.default.func.isRequired
};
var _default = exports.default = SearchDrawer;